// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"MapContainer_wrapper__1U0Qi","wrapper_full":"MapContainer_wrapper_full__3OQfu"};